import {getReservationList, getTodayReservationStat, signReOrder} from "@/api";
import {message, getTodayDate, errorMsg} from "../../utils/common";
import {ElMessageBox} from "element-plus";
import baseConfig from "@/api/config";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                schDate: getTodayDate(),
                reStatus: '',
                isFree: '',
                cardPatientName: '',
                cardIdentity: '',
                reStatusMiniDoc: '',
                cardPatientPhone: '',
                doctorName: ''
            },
            tableLoading: false,
            statLoading: false,
            statRequestId: 0,
            listRequestId: 0,
            statData: {},
            statCards: [
                {key: 'waitSign', label: '待签到', status: '8', className: 'stat_card_wait_sign', icon: 'Clock'},
                {key: 'waitVisit', label: '待就诊', status: '5', className: 'stat_card_wait_visit', icon: 'UserFilled'},
                {key: 'visiting', label: '就诊中', status: '6', className: 'stat_card_visiting', icon: 'FirstAidKit'},
                {key: 'done', label: '已完成', status: '2', className: 'stat_card_done', icon: 'CircleCheck'},
                {key: 'cancel', label: '已取消/失效', status: '', isFree: '1', className: 'stat_card_cancel', icon: 'CircleClose'}
            ],
            tableData: [],
            dateTime: '',
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: null,
            patientInfo: {}
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            if (this.$refs.multipleTable && this.$refs.multipleTable.$el) {
                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
            }
        },1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
        }
        this.searchReservations();
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.cardPatientName = "";
            this.queryParams.reStatusMiniDoc = "";
            this.queryParams.cardIdentity = "";
            this.queryParams.cardPatientPhone = "";
            this.queryParams.doctorName = "";
            this.queryParams.schDate = getTodayDate();
            this.queryParams.reStatus = '';
            this.queryParams.isFree = '';
            this.searchReservations();
        },

        searchReservations() {
            if (!this.queryParams.schDate) this.queryParams.schDate = getTodayDate();
            this.currentPage = 1;
            this.getReservationStatInfo();
            return this.getReservationListInfo();
        },

        getReservationStatInfo() {
            const requestId = ++this.statRequestId;
            this.statLoading = true;
            this.statData = {};
            return getTodayReservationStat({
                schDate: this.queryParams.schDate,
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null
            }).then(res => {
                if (requestId !== this.statRequestId) return;
                const payload = res.data;
                if (payload.code === 200) {
                    this.statData = payload.data || {};
                } else {
                    message(payload.msg || '预约汇总加载失败', 'warning');
                }
            }).catch(error => {
                if (requestId === this.statRequestId) message(error, 'error');
            }).finally(() => {
                if (requestId === this.statRequestId) this.statLoading = false;
            });
        },

        filterByStatus(status, isFree = '') {
            this.queryParams.reStatus = status;
            this.queryParams.isFree = isFree;
            this.queryParams.reStatusMiniDoc = '';
            this.currentPage = 1;
            return this.getReservationListInfo();
        },

        // 选择预约状态
        chooseStatus() {
            this.queryParams.reStatus = '';
            this.queryParams.isFree = '';
            this.currentPage = 1;
            this.getReservationListInfo();
        },

        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getReservationListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.currentPage = 1;
            this.getReservationListInfo();
        },


        // 查询预约列表
        getReservationListInfo: function () {
            const requestId = ++this.listRequestId;
            this.tableData = [];
            this.tableLoading = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                schDate: this.queryParams.schDate,
                reStatus: this.queryParams.reStatus,
                isFree: this.queryParams.isFree,
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
                cardIdentity: this.queryParams.cardIdentity,
                cardPatientName: this.queryParams.cardPatientName,
                reStatusMiniDoc: this.queryParams.reStatusMiniDoc,
                cardPatientPhone: this.queryParams.cardPatientPhone,
                doctorName: this.queryParams.doctorName,
            };
            return getReservationList(data).then(res => {
                if (requestId !== this.listRequestId) return;
                const rdata = res.data;
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        //出生日期缺失时不能 new Date(null)（得 1970 → 显示 56 岁），空值显示 '--'
                        let birYear = item.cardPatientBirth ? new Date(item.cardPatientBirth).getFullYear() : null;
                        let nowYear = new Date().getFullYear();
                        item.age = birYear ? parseInt(nowYear - birYear) : '--';
                        item.reTimeTypeText = item.reTimeType === 'am'?'上午': item.reTimeType === 'pm'?'下午':'晚上';
                        item.reStatusText = item.reStatus === '1'?'待支付':item.reStatus === '2'?
                            '已完成':item.reStatus === '3'?'已失效':item.reStatus === '4'?'已取消':item.reStatus === '5'?'待就诊':item.reStatus === '6'?'就诊中':item.reStatus === '7'?'已过号':item.reStatus === '8'?'待签到':'未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = item.cardPatientHeadPic ? this.toAvatarUrl(item.cardPatientHeadPic) : this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1'){
                            item.sexText = '女';
                            item.avatar = item.cardPatientHeadPic ? this.toAvatarUrl(item.cardPatientHeadPic) : this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = item.cardPatientHeadPic ? this.toAvatarUrl(item.cardPatientHeadPic) : this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                if (requestId !== this.listRequestId) return;
                this.totalCount = 0;
                //axios reject 的是 Error 对象，直接丢给 ElMessage 会渲染成空白提示框
                message(errorMsg(error, '预约列表查询失败'), "error");
            }).finally(() => {
                if (requestId === this.listRequestId) this.tableLoading = false;
            });
        },


        toAvatarUrl(value) {
            return /^https?:\/\//i.test(value) ? value : this.tencentCosUrl + value;
        },

        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        this.getReservationStatInfo();
                        //后端签到时分配当天排队号，随签到结果回传
                        message(res.data ? "签到成功，排队" + res.data + "号" : "签到成功", "success");
                        this.getReservationListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getReservationListInfo();
                    }
                }).catch(error => {
                    message(errorMsg(error, "签到失败"), "error");
                });
            }).catch(() => {});
        },

    }
}
